module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fd2022f573561d6fcc1102f49fccf615.png";